import { WishlistPreview } from "@/features/wishlist/Wishlist";
import { AccountInfoPreview } from "./AccountInfo/AccountInfo";
import { OrderHistoryPreview } from "./Orders/Orders";
import styles from "./index.module.css";

const Overview = () => {
  return (
    <section className={styles.dashboardSection}>
      <div className={styles.orderHistorySection}>
        <OrderHistoryPreview />
      </div>
      <div className={styles.favouritesSection}>
        <div>
          <WishlistPreview />
        </div>
      </div>
      <div className={styles.accountDetailsSection}>
        <AccountInfoPreview />
      </div>
    </section>
  );
};

export default Overview;
